const iconsData = {
  'React.js': 'http://formatjs.io/img/react.svg',
  'Node.js': 'https://cdn2.iconfinder.com/data/icons/nodejs-1/512/nodejs-512.png',
  express: 'https://cdn2.iconfinder.com/data/icons/nodejs-1/512/nodejs-512.png',
  MySQL: 'https://seeklogo.com/images/M/MySQL-logo-17DB4E5FD6-seeklogo.com.png',
  'socket.io': 'https://www.pubnub.com/blog/wp-content/uploads/2014/07/SOCKETIOICON.gif',
  Ionic: 'http://uxrepo.com/static/icon-sets/ionicons/svg/ionic.svg',
  AngularJS: 'https://lh6.googleusercontent.com/-TlY7amsfzPs/T9ZgLXXK1cI/AAAAAAABK-c/Ki-inmeYNKk/w800-h800/AngularJS-Shield-large.png',
  MongoDB: 'http://www.todobackend.com/images/logos/mongodb.png',
  neo4j: 'https://avatars3.githubusercontent.com/u/218965?v=3&s=200',
  'd3.js': 'https://upload.wikimedia.org/wikipedia/en/thumb/1/15/Logo_D3.svg/1079px-Logo_D3.svg.png',
  Leaflet: 'http://leafletjs.com/docs/images/logo.png',
  Redux: 'https://rawgit.com/gorangajic/react-icons/master/react-icons.svg',
  RethinkDB: 'https://api.jujucharms.com/charmstore/v4/~adam-stokes/trusty/rethinkdb-slave-4/icon.svg',
  Docker: 'https://d3oypxn00j2a10.cloudfront.net/0.7.0/img/homepage/docker-whale-home-logo.png',
  Webpack: 'https://camo.githubusercontent.com/36f3c35d2994799ee2392b1d9d1b4b8f48d9c495/68747470733a2f2f63646e2e7261776769742e636f6d2f7765627061636b2f6d656469612f65373438356562322f6c6f676f2f69636f6e2e737667',
  Sass: 'http://sass-lang.com/assets/img/styleguide/seal-color-aef0354c.png',
  Django: 'https://sentry.io/_assets/logos/django-f6f336cde20615169bbf4441c748188dd9903908bc6af952df3bd8f899c55a41.svg',
  Python: 'https://upload.wikimedia.org/wikipedia/commons/thumb/c/c3/Python-logo-notext.svg/220px-Python-logo-notext.svg.png',
  PHP: 'https://sipexa.com/wp-content/uploads/php-logo.png',
  CSS: 'https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/726px-CSS3_logo_and_wordmark.svg.png'
};

export { iconsData };



// WEBPACK FOOTER //
// ./src/components/projectComponents/techStackIcons.js